module.exports = __webpack_public_path__ + "img/facebook-logo.4053fb1a.svg";